$(document).ready(function() {

// Mailto links
    $("a[href^='mailto']").on('click', function (e) {
        if (typeof ga != "undefined") {
            var ga_label = ($(this).data('ga-label') != undefined) ? ' (' + $(this).data('ga-label') + ')' : '';
            ga('send', {
                'hitType': 'event',
                'eventCategory': 'email',
                'eventAction': 'click',
                'eventLabel': $(this).attr('href').replace('mailto:', '') + ga_label
            });
        }
    });

// Tel links
    $("a[href^='tel:']").on('click', function (e) {

        if (typeof ga != "undefined") {
            var ga_label = ($(this).data('ga-label') != undefined) ? ' (' + $(this).data('ga-label') + ')' : '';

            ga('send', {
                'hitType': 'event',
                'eventCategory': 'telefon',
                'eventAction': 'click',
                'eventLabel': $(this).attr('href').replace('tel:', '') + ga_label
            });
        }
    });


// PDF links
    $("a[href$='pdf']").on('click', function (e) {
        if (typeof ga != "undefined") {
            var ga_label = ($(this).data('ga-label') != undefined) ? ' (' + $(this).data('ga-label') + ')' : '';
            ga('send', {
                'hitType': 'event',
                'eventCategory': 'pdf',
                'eventAction': 'click',
                'eventLabel': $(this).attr('href') + ga_label
            });
            ga('send', 'pageview', $(this).attr("href"));
        }
    });

// Defined tracked links
    $("a.track-click").on('click', function (e) {
        if (typeof ga != "undefined") {
            var ga_label = ($(this).data('ga-label') != undefined) ? $(this).data('ga-label') + ': ' : '';
            var ga_category = ($(this).data('ga-category') != undefined) ? $(this).data('ga-category') : 'tracked';
            ga('send', {
                'hitType': 'event',
                'eventCategory': ga_category,
                'eventAction': 'click',
                'eventLabel': ga_label + $(this).attr('href')
            });
        }
    });

// Defined external links
    $("a.track-external").on('click', function (e) {
        if (typeof ga != "undefined") {
            var ga_label = ($(this).data('ga-label') != undefined) ? $(this).data('ga-label') + ': ' : '';
            ga('send', {
                'hitType': 'event',
                'eventCategory': 'external',
                'eventAction': 'click',
                'eventLabel': ga_label + $(this).attr('href')
            });
        }
    });

// external links (not robust)
    /*$("a[href^=http]:not(:contains('xxx'))").on('click', function (e) {
        if (typeof ga != "undefined") {
            ga('send', {
                'hitType': 'event',
                'eventCategory': 'external-link',
                'eventAction': 'click',
                'eventLabel': $(this).attr('href')
            });
        }
    });*/

});


// WEBPACK FOOTER //
// ./resources/js/tracking/frontend.google-analytics.js